<!--

ARoads
------

-->

<template>

    <div class="app-container">

        <transition name="component-fade" mode="out-in">
            <map-tab v-if="tab == 'map'" />
            <card-tab v-if="tab == 'card'" />
        </transition>

        <!--<div class="controls-container">
            <div class="controls d-flex align-items-center bg-white p-2">

                <h2 class="mb-0 mr-2">A Roads!</h2>

                <ul class="nav nav-pills">
                    <li class="nav-item">
                        <span class="nav-link"
                            :class="{active: tab == 'map', 'text-primary': tab != 'map'}"
                            @click="navigate('map')">
                            Map
                        </span>
                    </li>
                    <li class="nav-item">
                        <span class="nav-link"
                            :class="{active: tab == 'card', 'text-primary': tab != 'card'}"
                            @click="navigate('card')">
                            Buy Gift Cards
                        </span>
                    </li>
                </ul>

            </div>
        </div>-->

        <alert-handler></alert-handler>
    </div>
</template>

<style lang="scss" scoped>
    .controls-container {
        position: absolute;
        left: 0;
        top: 0;
        .controls {
            box-shadow: 1px 1px 3px 1px rgba(0,0,0,0.2);
        }
    }

    .component-fade-enter-active, .component-fade-leave-active {
        transition: opacity .5s ease;
    }
    .component-fade-enter, .component-fade-leave-to {
        opacity: 0;
    }

    .nav-link {
        cursor: pointer;
        transition: background-color .5s ease;
    }
</style>

<style lang="scss">
    @import './scss/app.scss';
</style>

<script>
    import MapTab from '@/components/tabs/MapTab.vue';
    import CardTab from '@/components/tabs/CardTab.vue';
    import AlertHandler from '@/components/common/AlertHandler';

    export default {
        components: {
            MapTab,
            CardTab,
            AlertHandler,
        },
        data: function() {
            return {
                tab: 'map'
            }
        },
        methods: {
            navigate: function(tab) {
                this.tab = tab;
            }
        }
    }
</script>
